import { render, staticRenderFns } from "./VStepInput.vue?vue&type=template&id=6190a0dc&"
import script from "./VStepInput.vue?vue&type=script&lang=js&"
export * from "./VStepInput.vue?vue&type=script&lang=js&"
import style0 from "./VStepInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default,VBtn: require('/app/components/ui/v-btn/VBtn.vue').default})
